import run from '../../utilities/run';
import $ from 'jquery';
const _ = require("underscore");

run(".amazon-connection-detail", ()=>{
	const el = $(".amazon-connection-detail");
	const editPartnerUrl = el.data("amazon-edit-channel-connection-url");
	const inactivateRetPartnerUrl = el.data("amazon-inactivate-channel-url");
	const activateChannelUrl = el.data("amazon-activate-channel-url");
	const viewConnectionDetailUrl = el.data("amazon-view-channel-connection-detail-url");
	const retpartnerJson = el.data("retailer-partners-info");
	const viewChannelDetailUrl = el.data("view-channel-detail-url");
	const modalInactivateChannel = $("#modalInactivateChannel");
	const modalActivateChannel = $("#modalActivateChannel");

	$(".inactivate").on( "click", function() {
		$("#deleteModal").appendTo("body").modal("show");
	});
	
	$(".activate").on( "click", function() {
		$("#activateModal").appendTo("body").modal("show");
	});

	modalInactivateChannel.on( "click", function() {
		inactivateRetPartner();
	});

	modalActivateChannel.on( "click", function() {
		activateRetailerPartner();
	});

	function inactivateRetPartner() {
		$.ajax({ 
			url: inactivateRetPartnerUrl,
			success: function(data){ 
				if(data.match("success")){
					location.href=viewChannelDetailUrl;
				}else{
					alert('<liferay-ui:message key="general-error-message"/>');
				}
			},
			error: function(data) {
				alert('<liferay-ui:message key="general-error-message"/>');
			}
		});	
 	}

 	function activateRetailerPartner() {
		$.ajax({ 
			url: activateChannelUrl,
			success: function(data){ 
				if(data.match("success")){
					location.href=viewChannelDetailUrl;
				}else{
					alert('<liferay-ui:message key="general-error-message"/>');
				}
			},
			error: function(data) {
				alert('<liferay-ui:message key="general-error-message"/>');
			}
		});	
	}


});


// WEBPACK FOOTER //
// ./src/pages/createChannel/amazonConnectionDetails.js